import Cookies from 'js-cookie';

const TokenKey = 'Admin-Token';

const UserName = 'UserName';

const password = 'passWord';

const tenantType = 'tenantType';

const loginType = 'loginType';
// 搜索记录
const searchLog = 'searchLog';
// 客服链接
const customerService = 'customerService';
// 登陆系统
const storeType = 'storeType';
//是否有企业商品
const ifEnterpriseGoods = "ifEnterpriseGoods";

export function setIfEnterprise(val) {
  return Cookies.set(ifEnterpriseGoods, val);
}

export function getIfEnterprise() {
  return Cookies.get(ifEnterpriseGoods);
}
export function setSearchLog(type) {
  return Cookies.set(searchLog, type);
}

export function getSearchLog() {
  return Cookies.get(searchLog);
}

export function setLoginType(type) {
  return Cookies.set(loginType, type);
}

export function getLoginType() {
  return Cookies.get(loginType);
}

export function getToken() {
  return Cookies.get(TokenKey);
}

export function setTenantType(type) {
  return Cookies.set(tenantType, type);
}

export function getTenantType() {
  return Cookies.get(tenantType);
}

export function setUserName(token) {
  return Cookies.set(UserName, token);
}

export function getUserName() {
  return Cookies.get(UserName);
}

export function setPassWord(value) {
  return Cookies.set(password, value);
}

export function getPassWord() {
  return Cookies.get(password);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token);
}

export function getCustomerService() {
  return Cookies.get(customerService);
}

export function setCustomerService(href) {
  return Cookies.set(customerService, href);
}

export function getStoreType() {
  return Cookies.get(storeType);
}

export function setStoreType(value) {
  return Cookies.set(storeType, value);
}

export function removeToken() {
  Cookies.remove('realName');
  return Cookies.remove(TokenKey);
}
export function removeUserName() {
  Cookies.remove(UserName);
  return Cookies.remove(UserName);
}



// WEBPACK FOOTER //
// ./src/utils/auth.js